<template>
  <div class="developer">
    <div class="developer-content">
      <div class="content-wrap">
        <div class="info-header">
          <div class="title">{{userinfo.companyName}}</div>
          <div class="add">详细地址:{{userinfo.companyAddress}}</div>
          <div class="time">注册时间:{{userinfo.registerTime}}</div>
          <div>
            <el-button type="primary">用户详情</el-button>
            <el-button plain @click="goto('developerdetail')">接口管理</el-button>
            <el-button plain @click="goto('summarydetail')">调用统计</el-button>
          </div>
          <div class="user">
            <img v-if="devStatus == '2'" src="../../../assets/images/icon/on-use.png"/><span v-if="devStatus == '2'" style="color:#996e52;">正式用户</span>
            <img v-if="devStatus == '1'" src="../../../assets/images/icon/try.png"/><span v-if="devStatus == '1'" style="color:#479efe;">试用用户</span>
            <img v-if="devStatus == '3'" src="../../../assets/images/icon/outDate.png"/><span v-if="devStatus == '3'" style="color:#666;">过期用户</span>
            <img v-if="devStatus == '0'" src="../../../assets/images/icon/invalid.png"/><span v-if="devStatus == '0'" style="color:#878787">未生效用户</span>
            <img v-if="devStatus == '4'" src="../../../assets/images/icon/forbiden.png"/><span v-if="devStatus == '4'" style="color:#ed4a3a;">禁用用户</span>
            <img v-if="devStatus == '5'" src="../../../assets/images/icon/other.png"/><span v-if="devStatus == '5'" style="color:#4a6589;">其他用户</span>
          </div>
        </div>
        <div style="background:white;margin-top:20px;overflow: hidden;">
          <div class="accountinfo info_item">
            <div style="font-size: 18px;font-weight: bold;margin-top:10px;">开发者账户信息</div>
            <div class="info_form">
              <table width="100%" class="info-table">
                <tr>
                  <td class="table-title">用户ID：</td>
                  <td>{{userinfo.id}}</td>
                  <td class="table-title">账号：</td>
                  <td>{{userinfo.mobile}}</td>
                </tr>
                <tr>
                  <td class="table-title">clientId：</td>
                  <td>{{userinfo.clientId}}</td>
                  <td class="table-title">clientSecret：</td>
                  <td>{{userinfo.clientSecret}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="accountinfo info_item">
            <div style="font-size: 18px;font-weight: bold;margin-top:10px;">联系人</div>
            <div class="info_form">
              <table width="100%" class="info-table">
                <tr>
                  <td class="table-title">业务联系人：</td>
                  <td>{{userinfo.businessContact}}</td>
                  <td class="table-title">手机号码：</td>
                  <td>{{userinfo.contactNumber}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="accountinfo info_item">
            <div style="font-size: 18px;font-weight: bold;margin-top:10px;">营业执照</div>
            <div>
              <div style="text-align:center;" v-if="userinfo.businessLicenseUrl">
                <img style="width:300px;height:300px" :src="userinfo.businessLicenseUrl"/>
              </div>
            </div>
          </div>
          <div class="accountinfo info_item">
            <div style="font-size: 18px;font-weight: bold">开通历史</div>
            <div>
              <!-- 按调用量开通 显示资源 -->
              <!-- <el-table class="resource-class" :data="history.content" header-row-class-name="header-row-class-name" border style="width: 100%">
                <el-table-column label="ID" prop="id" align="center"></el-table-column>
                <el-table-column label="操作类型" prop="optional" align="center"></el-table-column>
                <el-table-column label="开通类型" prop="type" align="center">
                  <template slot-scope="scope">
                    {{scope.row.type == 1 ? "按时段" : "按数量"}}
                  </template>
                </el-table-column>
                <el-table-column label="操作记录" align="center">
                  <template slot-scope="scope">
                    <div v-if="scope.row.type == 1">{{scope.row.startTime + ' 至 ' + scope.row.endTime}}</div>
                    <div v-if="scope.row.type == 2">
                      <div></div>
                      {{scope.row.questionLimit + "道，"+ scope.row.downloadDocumentLimit + "份，" + scope.row.invokeLimit + "次，"+scope.row.eliteschoolDownloadLimit + "次"}}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column label="操作时间" prop="createTime" align="center"></el-table-column>
              </el-table> -->

              <el-table class="resource-class" :data="history.content" header-row-class-name="header-row-class-name" border style="width: 100%">
                <el-table-column label="ID" prop="id" align="center"></el-table-column>
                <el-table-column label="操作类型" prop="optional" align="center"></el-table-column>
                <el-table-column label="开通类型" prop="type" align="center">
                  <template slot-scope="scope">
                    {{scope.row.type == 1 ? "按时段" : "按数量"}}
                  </template>
                </el-table-column>
                <el-table-column label="操作记录" align="center">
                  <template slot-scope="scope">
                    <span v-if="scope.row.apiResourceDto && scope.row.apiResourceDto.resourceType === 1">普通</span><span v-if="scope.row.apiResourceDto && scope.row.apiResourceDto.resourceType === 2">精品</span><span v-if="scope.row.apiResourceDto">{{scope.row.apiResourceDto.name}}接口:</span>
                    <span v-if="scope.row.type == 1">{{scope.row.startTime + ' 至 ' + scope.row.endTime}}</span>
                    <span v-if="scope.row.type == 2">
                      {{'(接口调用限制:'+scope.row.invokeLimit + "次，接口下载数量:"+ scope.row.downloadLimit + "次)" }}
                    </span>
                  </template>
                </el-table-column>
                <el-table-column label="操作时间" prop="createTime" align="center"></el-table-column>
              </el-table>
              <div style="text-align:center;margin-top:10px;">
                <el-pagination
                  background
                  @current-change="fetchDevResourceHistory"
                  :current-page.sync="pageNumber"
                  :page-size="pageSize"
                  layout="total, prev, pager, next"
                  :total="total">
                </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script type="text/babel">
import devService from '@/service/devService'
import {mapGetters} from 'vuex'
export default {
  data: function () {
    return {
      menus: [],
      pagedefault: '/front/developer',
      history: {},
      pageNumber: 0,
      pageSize: 10,
      total: 0,
      devStatus: ''
    }
  },
  name: 'developer',
  computed: {
    ...mapGetters(['userinfo', 'devdefaultvx'])
  },
  watch: {
    devdefaultvx (newVal, oldVal) {
      this.pagedefault = newVal
    }
  },
  mounted () {
    // 判断是否已经登录
    if (!this.userinfo.clientId) {
      this.$router.push({path: '/front/login'})
    } else {
      // 实现路由切换
      if (this.pagedefault !== '/front/developer') {
        this.$router.push({path: this.pagedefault})
      }
      this.fetchDevResourceHistory()
      this.getDeveloperStatus()
    }
  },
  methods: {
    // 获取开发者状态
    async getDeveloperStatus () {
      try {
        this.devStatus = await devService.getDeveloperStatus({developerId: this.userinfo.id})
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    // 查询用户开通历史
    async fetchDevResourceHistory () {
      try {
        this.history = await devService.fetchDevResourceHistory({userId: this.userinfo.id, pageNumber: this.pageNumber, pageSize: this.pageSize, isClient: 1})
        // 过滤apiResourceDto.name是试题的，然后questionV4的改名为试题
        this.history.content = this.history.content.filter(item => item.apiResourceDto.name !== '试题')
        this.history.content.forEach(item => {
          if (item.apiResourceDto.name === 'questionV4') {
            item.apiResourceDto.name = '试题'
          }
        })
        this.total = this.history.totalElements
      } catch (e) {
        this.$message.error(e && e.msg)
      }
    },
    goto (name) {
      this.$router.push({name: name})
    }
  }
}
</script>
<style scoped>

  .developer{
    height: 100%;
    width: 100%;
    margin-top: 30px;
    /* padding-top: 60px; */
    padding-bottom: 60px;
    /* background-color: #F6F6F6;
    margin: 0 0; */
  }
  /* .developer * {
    color: #333333;
  } */
  .developer .developer-content{
    width: 1200px;
    margin: 0 auto;
    box-shadow:0px 5px 10px 0px rgba(0, 0, 0, 0.08);
  }

  .developer .developer-content .content-wrap .info-header{
    background: #ffffff;
    padding: 20px 24px;
    position: relative;
    color: #333;
  }
  .developer .developer-content .content-wrap .info-header .title{
    font-size: 18px;
    font-weight: bold;
    margin-bottom: 20px;
  }
  .developer .developer-content .content-wrap .info-header .add,.developer .developer-content .content-wrap .info-header .time{
    font-size: 14px;
    color: gray;
    margin-bottom: 20px;
    max-width: 900px;
  }
  .developer .developer-content .content-wrap .info-header .user span{
    position: absolute;
    right: 121px;
    top: 54px;
    font-size: 18px;
    font-weight: bold;
  }
  .developer .developer-content .content-wrap .info-header .user img{
    position: absolute;
    right: 200px;
    top: 50px;
  }
  .developer .content-wrap .info_item{
    padding-left: 24px;
    padding-bottom: 10px;
    padding-right: 20px;
  }
  .developer .content-wrap .info_form {
    padding-left: 10px;
    padding-bottom: 10px;
    padding-right: 10px;
    border-bottom: 1px solid #eeeeee;
    overflow-y: auto;
  }
  .developer .content-wrap .info_form .info-table{
    margin-top: 10px;
    border-color:#EBEEF5 ;
  }
  .developer .content-wrap .info_form .info-table .table-title{
    background-color: #F2F2F2;
    width: 10%;
  }
  .developer .content-wrap .info_form .info-table td{
    height: 40px;
    width: 40%;
    padding-left: 20px;
    border: 1px solid #EBEEF5 ;
  }
  .developer .content-wrap  .info{
    height: 40px;
    font-size: 14px;
    font-weight: bold;
    text-align: center;
    line-height: 40px;
    vertical-align: middle;
  }
  .developer .content-wrap .info div{
    display: inline-block;
  }
  .developer .content-wrap .info  .info_label{
    width: 30%;
    float: left;
    text-align: right;
  }
  .developer .content-wrap .info .info_content{
    padding-left: 15px;
    text-align: left;
    float: left;
  }
  .developer .content-wrap .companyInfo .el-input{
    width: 80%;
  }
  .developer img.businessLicense{
    height: 40px;
    line-height: 40px;
    width: 40px;
    display: inline-block;
    vertical-align: middle;
    margin-left: 10px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/developer/index.vue